import React, { useState } from "react";
import DatePicker from "react-datepicker";
import de from "date-fns/locale/de"; // @todo Make dynamic
import { subDays } from "date-fns";
import Popup from "reactjs-popup";
import { ListItem, Div, Span, Header2 } from "../styled_components/exporter";
import { LocationsDropDown, PricesDropDown, AddNewPeriod } from "./exporter";
import { times } from "../utility/constants";
import useCheckinTimesSidebar from "../hooks/useCheckinTimesSidebar";
import { Button } from "../styled_components/styled_button";
import t from "../../../helpers/t";
import { $ } from "../../../../../vendor";
import { rbac } from "../";
import useManagerHasLocation from "../hooks/useManagerHasLocation";
import { HolidayModal } from "../ui_components/uiExporter";
import { Biscuit } from "../../../../utils";
import useLocations from "../hooks/useLocations";
import usePricetariffs from "../hooks/usePricetariffs";
import SidebarFilter from "../../../components/SidebarFilter";
// Map field values from down to proper i18n-key!
const timeI18n = {
  Holiday: "holiday",
  Period: "regular_period",
  "no Check-In/No Booking": "no_checkin_no_booking",
};

const CheckInTimesSidebar = () => {
  const {
    handleChangeFrom,
    handleChangeTo,
    handleClick,
    handlePeriod,
    setCurrentCity,
    date,
    period,
    currentCity,
    setCurrentPrice,
    currentPrice,
    store,
    isOpen,
    setIsOpen,
    clickHandler,
  } = useCheckinTimesSidebar();

  const { managerHasLocation } = useManagerHasLocation(currentCity);

  const useUsageTypes = Biscuit.get("client.show_usage_types") === "true";
  const [select, setSelect] = useState(useUsageTypes ? "location" : "set");
  const { resultLocation, handleChangeLocation } = useLocations({
    currentCity,
    setCurrentCity,
    select,
  });

  const { result, handleChange } = usePricetariffs({
    currentPrice,
    setCurrentPrice,
    select,
  });

  const selectedDateFrom =
    date === null || date.from === null || new Date(date.from).getFullYear() <= 1970
      ? null
      : date.from;

  const selectedDateTo =
    date.to > date.from || new Date(date.to).getFullYear() <= 1970
      ? new Date(date.to).getFullYear() <= 1970
        ? null
        : date.to
      : date.from;

  const onToggleLeftBar = (ev) => {
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);
  };

  const onChange = (val) => {
    if (useUsageTypes && val !== "location" && val !== "price") {
      val = null;
    }
    setSelect(val);
    if (useUsageTypes && val !== "location" && val !== "price") {
      handleChange("set");
      handleChangeLocation("set");
    }
  };
  // const changeTime = (val) => {
  //     console.log(val);
  // }
  return (
    <>
      <header className="inb-c-left-bar__title column">
        <h1 className="inb-page-title">
          {useUsageTypes && select === "null"
            ? t("all_times")
            : (useUsageTypes && select === "location") || !useUsageTypes
              ? t("opening_times")
              : useUsageTypes && select === "price"
                ? t("price_season_times")
                : t("all_times")}
        </h1>
      </header>
      {useUsageTypes && (
        <>
          {
            <Div className="column">
              <SidebarFilter
                id="inb-c-left-bar-flist--orders-status"
                heading={t("for what", null, "capital")}
                type="list"
                data={[
                  { name: t("opening_times"), value: "location" },
                  { name: t("price_season_times", null, "capital"), value: "price" },
                ]}
                dataKey="value"
                selected={select}
                onChangeHandle={onChange}
              />
              <hr />
            </Div>
          }
        </>
      )}
      {select === "price" && (
        <>
          <Div className="column">
            <PricesDropDown
              currentPrice={currentPrice}
              setCurrentPrice={setCurrentPrice}
              select={select}
            />
          </Div>
          <hr />
        </>
      )}
      {(!useUsageTypes || select === "location") && (
        <>
          <Div className="column">
            <LocationsDropDown
              currentCity={currentCity}
              setCurrentCity={setCurrentCity}
              select={select}
            />
          </Div>
          <hr />
        </>
      )}

      {select !== null &&
        ((currentCity !== null && currentCity !== "") ||
          (currentPrice !== null && currentPrice !== "")) && (
          <>
            <Div className="column">
              <ul className="inb-vert-list">
                {times.map((time) => (
                  <ListItem
                    key={time}
                    className={time === date.day ? "active" : ""}
                    onClick={() => handleClick(time)}
                  >
                    {t("ot_" + time.toLowerCase())}
                  </ListItem>
                ))}
              </ul>
              <hr />
            </Div>
            <Div className="column">
              <Div>
                <HolidayModal isOpen={isOpen} setIsOpen={setIsOpen} location={currentCity} />
                <ul className="inb-vert-list">
                  <span className="inb-list-title">{t("dates")}</span>
                  <ListItem>
                    <>
                      <DatePicker
                        className="noBorders-noBackground"
                        dateFormat="dd.MM.y"
                        selected={selectedDateFrom}
                        onChange={(date) => handleChangeFrom(date)}
                        onKeyDown={(e) => {
                          if (e.keyCode === 8) e.preventDefault();
                        }}
                        placeholderText={t("valid_from", null, "capital") + "..."}
                        locale={de}
                      />
                      {selectedDateFrom !== null && (
                        <Span onClick={() => handleChangeFrom(null)}>
                          <i className="fi fi-x"></i>
                        </Span>
                      )}
                    </>
                  </ListItem>
                  <ListItem>
                    <>
                      <DatePicker
                        className="noBorders-noBackground"
                        dateFormat="dd.MM.y"
                        selected={selectedDateTo}
                        onChange={(date) => handleChangeTo(date)}
                        onKeyDown={(e) => {
                          if (e.keyCode === 8) e.preventDefault();
                        }}
                        minDate={
                          date.from ? subDays(new Date(date.from), 0) : subDays(new Date(), 0)
                        }
                        placeholderText={" ..." + t("valid_to", null, "capital")}
                        locale={de}
                      />
                      {selectedDateTo !== null && (
                        <Span onClick={() => handleChangeTo(null)}>
                          <i className="fi fi-x"></i>
                        </Span>
                      )}
                    </>
                  </ListItem>
                </ul>
              </Div>
              <Div>
                <ul className="inb-vert-list">
                  {["Holiday", "Period", "no Check-In/No Booking"].map((time) => (
                    <ListItem
                      className={time.toLowerCase() === period.toLowerCase() ? "active" : ""}
                      key={time}
                    >
                      <span onClick={() => handlePeriod(time)}>{t(timeI18n[time])}</span>

                      {period !== null && period !== "" && (
                        <a
                          href="#"
                          className="unset-filter"
                          onClick={() => handlePeriod("")}
                          title={t("unselect_filter")}
                        >
                          x
                        </a>
                      )}
                    </ListItem>
                  ))}
                </ul>
              </Div>
            </Div>
          </>
        )}

      {rbac.hasPermission("write") && managerHasLocation && (
        <footer
          id="inb-checkin-times-footer"
          className="inb-c-left-bar__footer small-only-float-container center-on-content"
        >
          <a
            href="#"
            id="toggle-left-bar"
            className="button secondary show-for-small-only"
            onClick={(e) => onToggleLeftBar(e)}
          >
            <i className="fi fi-filter"></i>
            <span className="show-for-sr">t('open_filter_menu')</span>
          </a>
          <AddNewPeriod currentLocation={currentCity} currentPrice={currentPrice} select={select} />
          <Popup
            id="popup-holiday"
            key={"SideBarPopUP"}
            style={{ padding: 0 }}
            trigger={
              <Button style={{ position: "absolute", left: "80%", top: "25px", zIndex: "10" }}>
                ...
              </Button>
            }
            position="top right"
          >
            {() => (
              <Header2 id="holy" onClick={clickHandler}>
                Select from holidays
              </Header2>
            )}
          </Popup>
        </footer>
      )}
    </>
  );
};

export default CheckInTimesSidebar;
